// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goods-removal[data-v-d5780d0c]{padding:32px 0 25px}.goods-removal__title[data-v-d5780d0c]{color:#161b25;font-size:22px;text-align:center;font-weight:700;margin-bottom:32px;line-height:1.5}.goods-removal[data-v-d5780d0c] .v-autocomplete .primary--text,.goods-removal[data-v-d5780d0c] .v-autocomplete .v-label{color:#161b25!important}.goods-removal[data-v-d5780d0c] .v-autocomplete fieldset{border:2px solid #161b25;border-radius:10px}", ""]);
// Exports
module.exports = exports;
